import styled from 'styled-components'

import Card from '@ilg-totallymoney/ui/components/Card'
import { focusStylesWithRoundedEdges } from '@ilg-totallymoney/ui/styles/focus'
import theme from '@ilg-totallymoney/ui/theme'

export const StyledButton = styled.button<{
    shouldShowMousePointer: boolean
}>`
    display: none;
    border: 0;
    padding: 0;
    background-color: transparent;

    ${theme.mediaMediumPlus`
      display: flex;
      align-self: center;
    `}

    ${focusStylesWithRoundedEdges};

    &:disabled {
        outline: 0;
    }

    &:hover {
        cursor: ${({ shouldShowMousePointer }) =>
            shouldShowMousePointer ? 'pointer' : 'cursor'};
    }
`

export const StyledCard = styled(Card)`
    &:last-of-type {
        margin-right: 0;

        ${theme.mediaMediumPlus`
          margin-right: 0;
        `}
    }
`
